export default __webpack_public_path__ + "static/media/expand.6169a706.svg";